export enum QueryKey {
  Assessments = 'assessments',
  CalendarEvents = 'calendarEvents',
  Calendars = 'calendars',
  CalendarShareTokens = 'calendarShareTokens',
  Curriculums = 'curriculums',
  CurriculumsOrg = 'curriculumsOrg',
  DailyStaffHoursSummaryReport = 'dailyStaffHoursSummaryReport',
  DailyStudentHoursSummaryReport = 'dailyStudentHoursSummaryReport',
  DiscoveryTopics = 'discoveryTopics',
  DiscoveryTopicsOrg = 'discoveryTopicsOrg',
  DropOffSpaces = 'dropOffSpaces',
  EmailUniqueness = 'emailuniqueness',
  EnrollmentCustomFields = 'enrollmentCustomFields',
  Enrollments = 'enrollments',
  ExternalSponsors = 'externalSponsors',
  Families = 'families',
  FamilyAttendees = 'familyAttendees',
  FeatureFlag = 'featureFlag',
  File = 'file',
  Groups = 'groups',
  GrowthIndicators = 'growthIndicators',
  Holidays = 'holidays',
  LearningReports = 'learningReports',
  LearningSettings = 'learningSettings',
  LessonPlans = 'lessonPlans',
  Lessons = 'lessons',
  MemberInfoChanges = 'memberInfoChanges',
  MemberPIN = 'memberPin',
  MemberPINReport = 'memberPinReport',
  Members = 'members',
  MessagingAdminDirectory = 'messagingAdminDirectory',
  MessagingFamilyDirectory = 'messagingFamilyDirectory',
  MessagingGroups = 'messagingGroups',
  MessagingInternalDirectory = 'messagingInternalDirectory',
  Notifications = 'notifications',
  PayrollReport = 'payrollReport',
  PhotoLibrary = 'photoLibrary',
  Programs = 'programs',
  PublicCenterInfo = 'publicCenterInfo',
  PublicOrgInfo = 'publicOrgInfo',
  PublicRegistrationLogs = 'publicRegistrationLogs',
  Routines = 'routines',
  Spaces = 'spaces',
  Staff = 'staff',
  StaffSignInDetailReport = 'staffSignInDetailReport',
  StudentInfoChanges = 'studentInfoChanges',
  StudentSignInDetailReport = 'studentSignInDetailReport',
  SubsidyClaimReport = 'subsidyClaimReport',
  SupportedVersions = 'supportedVersions',
  Tasks = 'tasks',
  Upload = 'upload',
}
